/* Megamenu */
$('.navigation-chevron').click(function (event) {
  var self = $(this).parent();
  $('.navigation-item').not(self).removeClass('open');
  self.toggleClass("open");
});

$(document).mouseup(function(e)
{
    var container = $("#navigation-wrapper");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('.navigation-megamenu-panel').collapse('hide');
        $('.navigation-submenu').collapse('hide');
        $('.navigation-item').removeClass('open');
    }
});
